import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../../config/apiConfig";

const postBlog = async (blogData) => {
  try {
    const { data } = await axiosInstance.post("/Blog", blogData);
    return data;
  } catch (error) {
    console.error("Error posting blog:", error);
    throw error;
  }
};

const usePostBlog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postBlog,
    onSuccess: () => {
      queryClient.invalidateQueries(["blogs"]);
    },
    onError: (err) => {
      console.error("Post blog mutation failed:", err);
    },
  });
};

export default usePostBlog;

